import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <main className="loading-screen" role="status" aria-live="polite"><span className="loader-mark"/><span>Preparing your secure workspace…</span></main>;
  }

  if (!user) return <Navigate to="/signin" replace />;
  return children ? <>{children}</> : <Navigate to="/workspace" replace />;
}
